// import StudioEditor from '@grapesjs/studio-sdk/react';
// import '@grapesjs/studio-sdk/style';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';
// import { config } from '../../../config';

// const LandingPageEditor = () => {
//   const { id } = useParams();
//   const apiUrl = config.apiUrl;

//   return (
//     <div style={{ height: '100vh', width: '100%' }}>
//     <StudioEditor
//       options={{
//         licenseKey: 'DEMO_LOCALHOST_KEY',
//         project: { type: 'web' },

//         storage: {
//           type: 'self',

//           onLoad: async () => {
//             const res = await axios.get(`${apiUrl}/landing-pages/${id}`);
//             const d = res.data.data;

//             return {
//               project: {
//                 pages: [
//                   {
//                     component: d.components ? JSON.parse(d.components) : d.html || '',
//                     styles: d.styles ? JSON.parse(d.styles) : d.css || ''
//                   }
//                 ],
//                 assets: d.assets ? JSON.parse(d.assets) : []
//               }
//             };
//           },


//           onSave: async ({ editor }) => {
//             const payload = {
//               html: editor.getHtml(),
//               css: editor.getCss(),

//               components: JSON.stringify(
//                 editor.getWrapper().toJSON()
//               ),

//               styles: JSON.stringify(
//                 editor.CssComposer.getAll().toJSON()
//               ),

//               assets: JSON.stringify(
//                 editor.AssetManager.getAll().map(a => a.toJSON())
//               )
//             };

//             await axios.post(`${apiUrl}/landing-pages/save/${id}`, payload);
//           },


//           autosaveChanges: 50,
//           autosaveIntervalMs: 10000
//         }
//       }}
//     />
//     </div>
//   );
// };

// export default LandingPageEditor;
import React, { useEffect, useRef } from 'react';
import grapesjs from 'grapesjs';
import 'grapesjs/dist/css/grapes.min.css';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { config } from '../../../config';
import imageCompression from 'browser-image-compression';

const LandingPageEditor = () => {
  const editorRef = useRef(null);
  const { id } = useParams();
  const apiUrl = config.apiUrl;

  useEffect(() => {
    if (editorRef.current) return;

    // 1️⃣ INIT EDITOR
    const editor = grapesjs.init({
      container: '#gjs',
      height: '100vh',
      width: '100%',
      fromElement: false,

      assetManager: {
        upload: false,

        uploadFile: async (e) => {
          const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
          const file = files[0];

          try {
            // 🔥 Compress Options
            const options = {
              maxSizeMB: 2,
              maxWidthOrHeight: 2560,
              useWebWorker: true,
              fileType: 'image/webp',
              initialQuality: 0.95 
            };

            const compressedFile = await imageCompression(file, options);

            const formData = new FormData();
            formData.append('file', compressedFile);

            const res = await axios.post(
              `${apiUrl}/upload-image`,
              formData,
              {
                headers: { 'Content-Type': 'multipart/form-data' }
              }
            );

            editor.AssetManager.add({
              src: res.data.data.src
            });

          } catch (err) {
            console.error("UPLOAD ERROR:", err);
          }
        }
      },

      canvas: {
        styles: [
          'https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css',
          'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css'
        ]
      }
    });

    editor.addStyle(`
      html {
        scroll-behavior: smooth;
      }
    `);



    // 2️⃣ LOAD FROM DATABASE (AFTER EDITOR READY)
    const loadFromServer = async () => {
      try {
        const res = await axios.get(`${apiUrl}/landing-pages/${id}`);
        const d = res.data.data;

        if (!d) return;

        // Components
        if (d.components) {
          editor.setComponents(JSON.parse(d.components));
        } else if (d.html) {
          editor.setComponents(d.html);
        }

        // Styles
        if (d.styles) {
          editor.setStyle(JSON.parse(d.styles));
        } else if (d.css) {
          editor.setStyle(d.css);
        }

        // Assets
        if (d.assets) {
          editor.AssetManager.add(JSON.parse(d.assets));
        }
      } catch (err) {
        console.error('Load failed', err);
      }
    };

    editor.on('load', loadFromServer);

    // 3️⃣ SAVE TO DATABASE
    const saveToServer = async () => {
      try {
        const payload = {
          html: editor.getHtml(),
          css: editor.getCss(),
          components: JSON.stringify(editor.getComponents().toJSON()),
          styles: JSON.stringify(editor.getStyle().toJSON()),
          // assets: JSON.stringify(
          //   editor.AssetManager.getAll().map(a => a.toJSON())
          // ),
        };

        console.log('Saving...', payload);

        await axios.post(`${apiUrl}/landing-pages/save/${id}`, payload);
      } catch (err) {
        console.error(err?.response?.data);
      }
    };

    // 4️⃣ AUTOSAVE (3s after change)
    editor.on('update', () => {
      clearTimeout(editor.__saveTimeout);
      editor.__saveTimeout = setTimeout(() => {
        saveToServer();
      }, 3000);
    });

    // 5️⃣ SAVE BUTTON
    editor.Commands.add('save-page', {
      run() {
        saveToServer();
        alert('✅ Page Saved');
      },
    });

    editor.Panels.addButton('options', {
      id: 'save-page',
      className: 'fa fa-save',
      command: 'save-page',
      attributes: { title: 'Save Page' },
    });

    // =======================
    // IMPORT HTML COMMAND
    // =======================
    editor.Commands.add('open-import-html', {
      run(editor) {
        const modal = editor.Modal;

        modal.setTitle('Import HTML Code');

        modal.setContent(`
          <div style="padding:10px">
            <textarea 
              id="import-html-area"
              style="width:100%;height:250px;padding:10px;border:1px solid #ddd;"
              placeholder="Paste your HTML code here..."
            ></textarea>

            <button 
              id="import-html-btn"
              style="margin-top:10px;padding:10px 20px;background:#2563eb;color:white;border:none;border-radius:6px;cursor:pointer;"
            >
              Import HTML
            </button>
          </div>
        `);

        modal.open();

        setTimeout(() => {
          const btn = document.getElementById('import-html-btn');
          const textarea = document.getElementById('import-html-area');

          btn.onclick = () => {
            const html = textarea.value;
            if (!html) return alert('Please paste HTML first');

            editor.setComponents(html);
            modal.close();
          };
        }, 0);
      }
    });

    editor.Panels.addButton('options', {
      id: 'import-html',
      className: 'fa fa-upload',
      command: 'open-import-html',
      attributes: { title: 'Import HTML' },
    });


    // =======================
    // Header Blocks
    // =======================

    editor.BlockManager.add('logo-header-minimal', {
      label: `
        <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-gem"></i>
          </div>
          <strong>Logo Header</strong>
          <div style="font-size:12px;color:#888">Minimal</div>
        </div>
      `,
      category: 'Header',
      content: `
        <header class="w-full bg-white shadow-sm">
          <div class="max-w-7xl mx-auto px-6 py-4 flex justify-center items-center">
            
            <a href="/" class="block">
              <img 
                src="https://via.placeholder.com/180x60?text=LOGO"
                alt="Logo"
                class="h-12 w-auto object-contain"
              />
            </a>

          </div>
        </header>
      `
    });

    editor.BlockManager.add('logo-header-luxury', {
      label: `
        <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-gem"></i>
          </div>
          <strong>Luxury Logo Header</strong>
          <div style="font-size:12px;color:#888">Dark Premium</div>
        </div>
      `,
      category: 'Header',
      content: `
        <header class="w-full bg-gradient-to-r from-black via-gray-900 to-black border-b border-yellow-500/30">
          <div class="max-w-7xl mx-auto px-6 py-5 flex justify-center items-center">
            
            <a href="/" class="block">
              <img 
                src="https://via.placeholder.com/180x60?text=LOGO"
                alt="Logo"
                class="h-14 w-auto object-contain drop-shadow-lg"
              />
            </a>

          </div>
        </header>
      `
    });

    editor.BlockManager.add('logo-header-emerald', {
      label: `
        <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-gem"></i>
          </div>
          <strong>Emerald Logo Header</strong>
          <div style="font-size:12px;color:#888">Islamic Luxury</div>
        </div>
      `,
      category: 'Header',
      content: `
        <header class="w-full bg-emerald-900 border-b border-yellow-400/30">
          <div class="max-w-7xl mx-auto px-6 py-5 flex justify-center items-center">
            
            <a href="/" class="block">
              <img 
                src="https://via.placeholder.com/180x60?text=LOGO"
                alt="Logo"
                class="h-14 w-auto object-contain"
              />
            </a>

          </div>
        </header>
      `
    });





    // =======================
    // Hero Blocks
    // =======================
    editor.BlockManager.add('attar-luxury-hero', {
  label: `
    <div style="text-align:center">
      <div style="font-size:22px;margin-bottom:6px;color:#facc15">
          <i class="fas fa-bolt"></i>
      </div>
      <strong>Luxury Hero</strong>
      <div style="font-size:12px;color:#888">Premium Design</div>
    </div>
  `,
  category: 'Hero',
  content: `
    <section class="relative overflow-hidden py-28 px-6 text-center text-white">

      <!-- Background Gradient -->
      <div class="absolute inset-0 bg-gradient-to-br from-black via-amber-900 to-yellow-700"></div>

      <!-- Golden Glow -->
      <div class="absolute top-[-100px] left-[-100px] w-[400px] h-[400px] bg-yellow-400 opacity-20 blur-3xl rounded-full"></div>
      <div class="absolute bottom-[-100px] right-[-100px] w-[400px] h-[400px] bg-amber-500 opacity-20 blur-3xl rounded-full"></div>

      <div class="relative max-w-4xl mx-auto">

        <!-- Badge -->
        <div class="inline-block mb-6 px-6 py-2 bg-white/10 backdrop-blur-md rounded-full text-sm tracking-wide border border-white/20">
          100% Halal & Alcohol Free
        </div>

        <!-- Headline -->
        <h1 class="text-4xl md:text-6xl font-bold leading-tight mb-6">
          Experience The Essence Of <span class="text-yellow-300">Pure Oud</span>
        </h1>

        <!-- Subheadline -->
        <p class="text-lg md:text-xl text-amber-100 mb-10 max-w-2xl mx-auto">
          Premium long-lasting attar crafted for Jummah, Eid & daily Sunnah.
          A fragrance that defines elegance.
        </p>

        <!-- Image -->
        <div class="mb-12">
          <img 
            src="https://via.placeholder.com/450x450"
            class="w-72 md:w-96 mx-auto rounded-3xl shadow-2xl border border-yellow-400/30"
          />
        </div>

        <!-- CTA -->
        <a href="#order"
           class="inline-block px-12 py-4 bg-yellow-400 text-black text-lg font-semibold rounded-full shadow-2xl luxury-cta">
           Order Now – Limited Stock
        </a>

      </div>
    </section>
  `
    });

    editor.BlockManager.add('attar-royal-black', {
  label: `
    <div style="text-align:center">
      <div style="font-size:22px;margin-bottom:6px;color:#facc15">
          <i class="fas fa-rocket"></i>
      </div>
      <strong>Royal Black Gold</strong>
      <div style="font-size:12px;color:#888">Luxury Dark</div>
    </div>
  `,
  category: 'Hero',
  content: `
    <section class="relative overflow-hidden py-28 px-6 text-center text-white">

      <div class="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-yellow-600"></div>

      <div class="absolute top-0 left-0 w-96 h-96 bg-yellow-500 opacity-10 blur-3xl rounded-full"></div>

      <div class="relative max-w-4xl mx-auto">

        <h1 class="text-4xl md:text-6xl font-bold mb-6">
          Discover The Power Of <span class="text-yellow-400">Royal Oud</span>
        </h1>

        <p class="text-lg text-gray-200 mb-10">
          A fragrance that speaks luxury, elegance and masculinity.
        </p>

        <div class="mb-12">
          <img src="https://via.placeholder.com/450x450"
            class="w-72 md:w-96 mx-auto rounded-3xl shadow-2xl border border-yellow-500/40" />
        </div>

        <a href="#order"
          class="px-12 py-4 bg-yellow-500 text-black font-semibold rounded-full shadow-xl hover:bg-yellow-400 transition">
          Shop Premium Attar
        </a>

      </div>
    </section>
  `
    });

    editor.BlockManager.add('attar-midnight-blue', {
  label: `
    <div style="text-align:center">
      <div style="font-size:22px;margin-bottom:6px;color:#facc15">
          <i class="fas fa-star"></i>
      </div>
      <strong>Midnight Blue</strong>
      <div style="font-size:12px;color:#888">Elite</div>
    </div>
  `,
  category: 'Hero',
  content: `
    <section class="relative overflow-hidden py-28 px-6 text-center text-white">

      <div class="absolute inset-0 bg-gradient-to-br from-blue-900 via-indigo-900 to-black"></div>

      <div class="relative max-w-4xl mx-auto">

        <h1 class="text-4xl md:text-6xl font-bold mb-6">
          The Signature Of <span class="text-indigo-400">Luxury</span>
        </h1>

        <p class="text-lg text-blue-200 mb-10">
          Crafted for those who lead with presence.
        </p>

        <div class="mb-12">
          <img src="https://via.placeholder.com/450x450"
            class="w-72 md:w-96 mx-auto rounded-3xl shadow-2xl border border-indigo-400/40" />
        </div>

        <a href="#order"
          class="px-12 py-4 bg-indigo-500 rounded-full shadow-xl hover:bg-indigo-400 transition">
          Explore Collection
        </a>

      </div>
    </section>
  `
    });


    editor.BlockManager.add('attar-emerald', {
      label: `
        <div style="text-align:center">
        <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-crown"></i>
          </div>
          <strong>Emerald Gold</strong>
          <div style="font-size:12px;color:#888">Islamic Premium</div>
        </div>
      `,
      category: 'Hero',
      content: `
        <section class="relative overflow-hidden py-28 px-6 text-center text-white">

          <div class="absolute inset-0 bg-gradient-to-br from-green-900 via-emerald-800 to-yellow-600"></div>

          <div class="relative max-w-4xl mx-auto">

            <h1 class="text-4xl md:text-6xl font-bold mb-6">
              Sunnah Inspired <span class="text-yellow-300">Fragrance</span>
            </h1>

            <p class="text-lg text-emerald-200 mb-10">
              A halal fragrance for Jummah & special occasions.
            </p>

            <div class="mb-12">
              <img src="https://via.placeholder.com/450x450"
                class="w-72 md:w-96 mx-auto rounded-3xl shadow-2xl border border-yellow-300/40" />
            </div>

            <a href="#order"
              class="px-12 py-4 bg-yellow-400 text-black rounded-full shadow-xl hover:bg-yellow-300 transition">
              Order Now
            </a>

          </div>
        </section>
      `
    });

    editor.BlockManager.add('hero-modern', {
    label: `
      <div style="text-align:center">
      <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-fire"></i>
          </div>
        <strong>Modern Hero</strong>
        <div style="font-size:12px;color:#888">Responsive</div>
      </div>
    `,
    category: 'Hero',
    content: `
      <section class="relative overflow-hidden bg-gradient-to-r from-indigo-600 to-blue-600 text-white">
        <div class="max-w-7xl mx-auto px-6 py-24 flex flex-col md:flex-row items-center gap-12">
          
          <!-- Content -->
          <div class="w-full md:w-1/2 text-center md:text-left">
            <h1 class="text-4xl md:text-5xl font-bold leading-tight mb-6">
              Build High Converting Landing Pages
            </h1>

            <p class="text-lg md:text-xl text-indigo-100 mb-8">
              Create beautiful, fast and responsive pages using our powerful builder.
            </p>

            <div class="flex flex-col sm:flex-row justify-center md:justify-start gap-4">
              <a href="#features"
                class="px-8 py-4 bg-white text-indigo-600 font-semibold rounded-full shadow-lg hover:bg-gray-200 transition">
                Get Started
              </a>

              <a href="#demo"
                class="px-8 py-4 border border-white rounded-full hover:bg-white hover:text-indigo-600 transition">
                Live Demo
              </a>
            </div>
          </div>

          <!-- Image -->
          <div class="w-full md:w-1/2">
            <img 
              src="https://via.placeholder.com/600x450"
              class="w-full rounded-xl shadow-2xl"
            />
          </div>

        </div>

        <!-- Decorative Blur -->
        <div class="absolute top-0 left-0 w-72 h-72 bg-white opacity-10 rounded-full blur-3xl"></div>
        <div class="absolute bottom-0 right-0 w-72 h-72 bg-white opacity-10 rounded-full blur-3xl"></div>
      </section>
    `
    });



    // =======================
    // Basic Blocks
    // =======================
    editor.BlockManager.add('section', {
      category: 'Basic',
      label: `
        <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-square"></i>
          </div>
          <strong>Section</strong>
          <div style="font-size:12px;color:#888">Responsive</div>
        </div>
      `,
      content: '<section style="padding:40px"></section>',
    });
    editor.BlockManager.add('clean-headline', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:22px;color:#2563eb;margin-bottom:6px">
            <i class="fas fa-heading"></i>
          </div>
          <strong>Clean Headline</strong>
          <div style="font-size:11px;color:#888">Minimal</div>
        </div>
      `,
      category: 'Basic',
      content: `
        <section class="py-14 px-6 text-center bg-white">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-900 leading-snug">
            A Headline That Instantly Grabs Attention
          </h2>
        </section>
      `
    });
    editor.BlockManager.add('text', {
      category: 'Basic',
      label: `
        <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-align-left"></i>
          </div>
          <strong>Text</strong>
          <div style="font-size:12px;color:#888">Responsive</div>
        </div>
      `,
      content: '<p>Write your text</p>',
    });
    editor.BlockManager.add('image', {
      category: 'Basic',
      label: `
        <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-image"></i>
          </div>
          <strong>Image</strong>
          <div style="font-size:12px;color:#888">Responsive</div>
        </div>
      `,
      content: { type: 'image' },
    });
    
    editor.BlockManager.add('attar-size-grid', {
      label: `
        <div style="text-align:center;padding:8px">
          <i class="fas fa-border-all" style="font-size:18px;color:#16a34a"></i>
          <div><strong>Editable Size Grid</strong></div>
          <div style="font-size:11px;color:#888">Responsive</div>
        </div>
      `,
      category: 'Basic',
      content: `
        <section class="py-20 px-6 bg-white">

          <div class="max-w-6xl mx-auto">

            <!-- Heading -->
            <div class="text-center mb-10">
              <h2 class="text-3xl md:text-4xl font-bold mb-4">
                Choose Your Perfect Attar Size
              </h2>
              <p class="text-gray-600">
                Select the size that fits your lifestyle.
              </p>
            </div>

            <!-- Desktop Grid Header -->
            <div class="hidden md:grid grid-cols-4 bg-black text-white font-semibold text-center rounded-t-xl">
              <div class="p-4">Size</div>
              <div class="p-4">Usage</div>
              <div class="p-4">Duration</div>
              <div class="p-4">Best For</div>
            </div>

            <!-- Row 1 -->
            <div class="grid md:grid-cols-4 border border-gray-200 text-center">

              <div class="p-4 font-semibold bg-gray-50 md:bg-white">
                3ML
              </div>

              <div class="p-4">
                Travel Use
              </div>

              <div class="p-4">
                7-10 Days
              </div>

              <div class="p-4">
                Trial Users
              </div>

            </div>

            <!-- Row 2 -->
            <div class="grid md:grid-cols-4 border border-gray-200 text-center md:border-t-0">

              <div class="p-4 font-semibold bg-gray-50 md:bg-white">
                6ML
              </div>

              <div class="p-4">
                Daily Use
              </div>

              <div class="p-4">
                15-20 Days
              </div>

              <div class="p-4">
                Regular Users
              </div>

            </div>

            <!-- Row 3 -->
            <div class="grid md:grid-cols-4 border border-gray-200 text-center md:border-t-0 rounded-b-xl">

              <div class="p-4 font-semibold bg-gray-50 md:bg-white">
                12ML
              </div>

              <div class="p-4">
                Long Term Use
              </div>

              <div class="p-4">
                30+ Days
              </div>

              <div class="p-4">
                Heavy Users
              </div>

            </div>

          </div>

        </section>
      `
    });

    editor.BlockManager.add('attar-size-2col', {
  label: `
    <div style="text-align:center;padding:8px">
      <i class="fas fa-columns" style="font-size:18px;color:#16a34a"></i>
      <div><strong>2 Column Size Grid</strong></div>
      <div style="font-size:11px;color:#888">Responsive</div>
    </div>
  `,
  category: 'Basic',
  content: `
    <section class="py-16 px-6 bg-white">

      <div class="max-w-4xl mx-auto">

        <h2 class="text-3xl font-bold text-center mb-10">
          Available Sizes
        </h2>

        <!-- Row 1 -->
        <div class="grid md:grid-cols-2 border border-gray-200 text-center rounded-t-xl">
          <div class="p-4 bg-black text-white font-semibold">
            Size
          </div>
          <div class="p-4 bg-black text-white font-semibold">
            Details
          </div>
        </div>

        <div class="grid md:grid-cols-2 border border-gray-200 text-center">
          <div class="p-4 font-semibold bg-gray-50">
            3ML
          </div>
          <div class="p-4">
            Perfect for Travel & Trial Use
          </div>
        </div>

        <div class="grid md:grid-cols-2 border border-gray-200 text-center">
          <div class="p-4 font-semibold bg-gray-50">
            6ML
          </div>
          <div class="p-4">
            Ideal for Daily Use (15–20 Days)
          </div>
        </div>

        <div class="grid md:grid-cols-2 border border-gray-200 text-center rounded-b-xl">
          <div class="p-4 font-semibold bg-gray-50">
            12ML
          </div>
          <div class="p-4">
            Long-lasting Premium Option
          </div>
        </div>

      </div>

    </section>
  `
    });
    editor.BlockManager.add('attar-size-3col', {
      label: `
        <div style="text-align:center;padding:8px">
          <i class="fas fa-th-large" style="font-size:18px;color:#2563eb"></i>
          <div><strong>3 Column Size Grid</strong></div>
          <div style="font-size:11px;color:#888">Responsive</div>
        </div>
      `,
      category: 'Basic',
      content: `
        <section class="py-16 px-6 bg-gray-50">

          <div class="max-w-5xl mx-auto">

            <h2 class="text-3xl font-bold text-center mb-10">
              Choose Your Attar Size
            </h2>

            <!-- Header -->
            <div class="hidden md:grid md:grid-cols-3 bg-black text-white font-semibold text-center rounded-t-xl">
              <div class="p-4">Size</div>
              <div class="p-4">Usage Duration</div>
              <div class="p-4">Best For</div>
            </div>

            <!-- Row 1 -->
            <div class="grid md:grid-cols-3 border border-gray-200 text-center bg-white">
              <div class="p-4 font-semibold bg-gray-50 md:bg-white">
                3ML
              </div>
              <div class="p-4">
                7–10 Days
              </div>
              <div class="p-4">
                Trial & Travel
              </div>
            </div>

            <!-- Row 2 -->
            <div class="grid md:grid-cols-3 border border-gray-200 text-center bg-white">
              <div class="p-4 font-semibold bg-gray-50 md:bg-white">
                6ML
              </div>
              <div class="p-4">
                15–20 Days
              </div>
              <div class="p-4">
                Daily Users
              </div>
            </div>

            <!-- Row 3 -->
            <div class="grid md:grid-cols-3 border border-gray-200 text-center bg-white rounded-b-xl">
              <div class="p-4 font-semibold bg-gray-50 md:bg-white">
                12ML
              </div>
              <div class="p-4">
                30+ Days
              </div>
              <div class="p-4">
                Heavy Use
              </div>
            </div>

          </div>

        </section>
      `
    });






      // =======================
    // List Blocks
    // =======================

    editor.BlockManager.add('list-clean-modern', {
  label: `
    <div style="text-align:center;padding:8px">
      <div style="font-size:22px;color:#2563eb;margin-bottom:6px">
        <i class="fas fa-list"></i>
      </div>
      <strong>Clean Modern</strong>
      <div style="font-size:11px;color:#888">Minimal</div>
    </div>
  `,
  category: 'Lists',
  content: `
    <section class="py-20 px-6 bg-white">
      <div class="max-w-6xl mx-auto grid md:grid-cols-2 gap-12">

        <div>
          <h2 class="text-3xl font-bold mb-6 text-gray-900">
            Key Features
          </h2>

          <ul class="space-y-4">
            <li class="flex gap-3">
              <span class="w-2 h-2 bg-blue-600 rounded-full mt-2"></span>
              <span class="text-gray-700">Premium Quality</span>
            </li>
            <li class="flex gap-3">
              <span class="w-2 h-2 bg-blue-600 rounded-full mt-2"></span>
              <span class="text-gray-700">Elegant Packaging</span>
            </li>
          </ul>
        </div>

        <div>
          <h2 class="text-3xl font-bold mb-6 text-gray-900">
            Ordering Steps
          </h2>

          <ol class="space-y-4">
            <li class="flex gap-4">
              <span class="text-blue-600 font-bold">01</span>
              <span class="text-gray-700">Click Order</span>
            </li>
            <li class="flex gap-4">
              <span class="text-blue-600 font-bold">02</span>
              <span class="text-gray-700">Confirm Delivery</span>
            </li>
          </ol>
        </div>

      </div>
    </section>
  `
    });
    editor.BlockManager.add('ordered-modern-border', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:20px;color:#2563eb;margin-bottom:6px">
            <i class="fas fa-stream"></i>
          </div>
          <strong>Ordered Modern</strong>
          <div style="font-size:11px;color:#888">Left Border</div>
        </div>
      `,
      category: 'Lists',
      content: `
        <section class="py-20 px-6 bg-gray-100">
          <div class="max-w-4xl mx-auto">
            <h2 class="text-3xl font-bold text-gray-900 mb-10 text-center">
              Simple Process
            </h2>

            <ol class="space-y-6">
              <li class="border-l-4 border-blue-600 pl-6">
                <span class="text-blue-600 font-bold text-lg">Step 01</span>
                <p class="text-gray-600">Choose your fragrance</p>
              </li>
              <li class="border-l-4 border-blue-600 pl-6">
                <span class="text-blue-600 font-bold text-lg">Step 02</span>
                <p class="text-gray-600">Place your order online</p>
              </li>
              <li class="border-l-4 border-blue-600 pl-6">
                <span class="text-blue-600 font-bold text-lg">Step 03</span>
                <p class="text-gray-600">Receive at your doorstep</p>
              </li>
            </ol>
          </div>
        </section>
      `
    });
    editor.BlockManager.add('unordered-check-style', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:20px;color:#10b981;margin-bottom:6px">
            <i class="fas fa-check-circle"></i>
          </div>
          <strong>Unordered Check</strong>
          <div style="font-size:11px;color:#888">Green Check</div>
        </div>
      `,
      category: 'Lists',
      content: `
        <section class="py-20 px-6 bg-white">
          <div class="max-w-4xl mx-auto">
            <h2 class="text-3xl font-bold text-gray-900 mb-10 text-center">
              Product Highlights
            </h2>

            <ul class="space-y-4">
              <li class="flex gap-3 items-start">
                <i class="fas fa-check-circle text-green-500 mt-1"></i>
                <span class="text-gray-700">100% Alcohol Free</span>
              </li>
              <li class="flex gap-3 items-start">
                <i class="fas fa-check-circle text-green-500 mt-1"></i>
                <span class="text-gray-700">Long Lasting Aroma</span>
              </li>
              <li class="flex gap-3 items-start">
                <i class="fas fa-check-circle text-green-500 mt-1"></i>
                <span class="text-gray-700">Premium Imported Oil</span>
              </li>
            </ul>
          </div>
        </section>
      `
    });
    editor.BlockManager.add('unordered-minimal-dot', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:20px;color:#ef4444;margin-bottom:6px">
            <i class="fas fa-circle"></i>
          </div>
          <strong>Unordered Minimal</strong>
          <div style="font-size:11px;color:#888">Simple Dot</div>
        </div>
      `,
      category: 'Lists',
      content: `
        <section class="py-20 px-6 bg-gray-50">
          <div class="max-w-4xl mx-auto">
            <h2 class="text-3xl font-bold text-gray-900 mb-10 text-center">
              Why Choose Us
            </h2>

            <ul class="space-y-4">
              <li class="flex gap-3 items-start">
                <span class="w-3 h-3 bg-red-500 rounded-full mt-2"></span>
                <span class="text-gray-700">Luxury Bottle Design</span>
              </li>
              <li class="flex gap-3 items-start">
                <span class="w-3 h-3 bg-red-500 rounded-full mt-2"></span>
                <span class="text-gray-700">Strong Projection</span>
              </li>
              <li class="flex gap-3 items-start">
                <span class="w-3 h-3 bg-red-500 rounded-full mt-2"></span>
                <span class="text-gray-700">Perfect For Jummah</span>
              </li>
            </ul>
          </div>
        </section>
      `
    });
    editor.BlockManager.add('unordered-two-col-card', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:20px;color:#8b5cf6;margin-bottom:6px">
            <i class="fas fa-th-large"></i>
          </div>
          <strong>2 Column Card List</strong>
          <div style="font-size:11px;color:#888">Responsive Grid</div>
        </div>
      `,
      category: 'Lists',
      content: `
        <section class="py-20 px-6 bg-white">
          <div class="max-w-5xl mx-auto">
            
            <h2 class="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
              Product Features
            </h2>

            <ul class="grid grid-cols-1 md:grid-cols-2 gap-6">
              
              <li class="flex gap-4 p-6 bg-gray-50 rounded-2xl shadow-sm hover:shadow-lg transition">
                <i class="fas fa-check text-purple-600 mt-1"></i>
                <span class="text-gray-700">Long Lasting Premium Aroma</span>
              </li>

              <li class="flex gap-4 p-6 bg-gray-50 rounded-2xl shadow-sm hover:shadow-lg transition">
                <i class="fas fa-check text-purple-600 mt-1"></i>
                <span class="text-gray-700">100% Alcohol Free & Halal</span>
              </li>

              <li class="flex gap-4 p-6 bg-gray-50 rounded-2xl shadow-sm hover:shadow-lg transition">
                <i class="fas fa-check text-purple-600 mt-1"></i>
                <span class="text-gray-700">Luxury Packaging Design</span>
              </li>

              <li class="flex gap-4 p-6 bg-gray-50 rounded-2xl shadow-sm hover:shadow-lg transition">
                <i class="fas fa-check text-purple-600 mt-1"></i>
                <span class="text-gray-700">Perfect For Jummah & Eid</span>
              </li>

            </ul>

          </div>
        </section>
      `
    });
    editor.BlockManager.add('unordered-two-col-minimal', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:20px;color:#f59e0b;margin-bottom:6px">
            <i class="fas fa-list"></i>
          </div>
          <strong>2 Column Minimal</strong>
          <div style="font-size:11px;color:#888">Elegant Clean</div>
        </div>
      `,
      category: 'Lists',
      content: `
        <section class="py-20 px-6 bg-gray-100">
          <div class="max-w-5xl mx-auto">

            <h2 class="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
              Why Customers Love Us
            </h2>

            <ul class="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
              
              <li class="flex items-start gap-3">
                <i class="fas fa-check text-purple-600 mt-1"></i>
                <span class="text-gray-700">Premium Imported Oil</span>
              </li>

              <li class="flex items-start gap-3">
                <i class="fas fa-check text-purple-600 mt-1"></i>
                <span class="text-gray-700">Strong Projection & Longevity</span>
              </li>

              <li class="flex items-start gap-3">
                <i class="fas fa-check text-purple-600 mt-1"></i>
                <span class="text-gray-700">Elegant Gift Ready Packaging</span>
              </li>

              <li class="flex items-start gap-3">
                <i class="fas fa-check text-purple-600 mt-1"></i>
                <span class="text-gray-700">Trusted By 12,000+ Customers</span>
              </li>

            </ul>

          </div>
        </section>
      `
    });

    editor.BlockManager.add('unordered-two-col-hand-pointer', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:20px;color:#ef4444;margin-bottom:6px">
            <i class="fas fa-hand-point-right"></i>
          </div>
          <strong>Hand Pointer List</strong>
          <div style="font-size:11px;color:#888">Two Column</div>
        </div>
      `,
      category: 'Lists',
      content: `
        <section class="py-20 px-6 bg-white">
          <div class="max-w-5xl mx-auto">

            <h2 class="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
              Why Choose Our Attar?
            </h2>

            <ul class="grid grid-cols-1 md:grid-cols-2 gap-6">

              <li class="flex gap-4 items-start">
                <i class="fas fa-hand-point-right text-red-500 text-xl mt-1"></i>
                <span class="text-gray-700 text-lg">
                  Long Lasting Premium Fragrance
                </span>
              </li>

              <li class="flex gap-4 items-start">
                <i class="fas fa-hand-point-right text-red-500 text-xl mt-1"></i>
                <span class="text-gray-700 text-lg">
                  100% Halal & Alcohol Free
                </span>
              </li>

              <li class="flex gap-4 items-start">
                <i class="fas fa-hand-point-right text-red-500 text-xl mt-1"></i>
                <span class="text-gray-700 text-lg">
                  Elegant Gift Packaging
                </span>
              </li>

              <li class="flex gap-4 items-start">
                <i class="fas fa-hand-point-right text-red-500 text-xl mt-1"></i>
                <span class="text-gray-700 text-lg">
                  Perfect For Jummah & Eid
                </span>
              </li>

            </ul>

          </div>
        </section>
      `
    });










    // =======================
    // Call To Action Blocks
    // =======================

    editor.BlockManager.add('cta-button', {
      label: `
        <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-hand-pointer"></i>
          </div>
          <strong>CTA Button</strong>
        </div>
      `,
      category: 'Buttons',
      content: `
        <a 
          href="#"
          class="cta-btn"
          style="
            display:inline-block;
            padding:14px 32px;
            background:linear-gradient(135deg,#ff7a18,#ffb347);
            color:#fff;
            font-size:16px;
            font-weight:600;
            border-radius:50px;
            text-decoration:none;
            transition:all .3s ease;
            box-shadow:0 10px 25px rgba(0,0,0,.15);
          "
        >
          Buy Now
        </a>
      `,
    });

    editor.BlockManager.add('cta-red-urgency', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:20px;color:#ef4444;margin-bottom:6px">
            <i class="fas fa-fire"></i>
          </div>
          <strong>Red Urgency Button</strong>
          <div style="font-size:11px;color:#888">High Conversion</div>
        </div>
      `,
      category: 'Buttons',
      content: `
        <div class="text-center py-10 bg-white">

          <a href="#order"
            class="inline-block px-12 py-4 bg-red-600 text-white text-lg font-bold rounded-full shadow-xl hover:bg-red-700 hover:scale-105 transition duration-300 animate-pulse">
            🔥 Order Now – Limited Stock
          </a>

          <p class="text-sm text-gray-500 mt-4">
            ⚠️ Only Few Bottles Left
          </p>

        </div>
      `
    });

    editor.BlockManager.add('cta-gold-luxury', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:20px;color:#facc15;margin-bottom:6px">
            <i class="fas fa-crown"></i>
          </div>
          <strong>Gold Luxury Button</strong>
          <div style="font-size:11px;color:#888">Premium Style</div>
        </div>
      `,
      category: 'Buttons',
      content: `
        <div class="text-center py-12 bg-black">

          <a href="#order"
            class="inline-block px-14 py-4 bg-yellow-400 text-black text-lg font-semibold rounded-full shadow-2xl hover:bg-yellow-300 hover:scale-105 transition duration-300">
            ✨ Get Premium Attar Now
          </a>

          <p class="text-yellow-300 mt-4 text-sm">
            Trusted By 12,000+ Customers
          </p>

        </div>
      `
    });

    editor.BlockManager.add('cta-blue-trust', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:20px;color:#3b82f6;margin-bottom:6px">
            <i class="fas fa-shield-alt"></i>
          </div>
          <strong>Blue Trust Button</strong>
          <div style="font-size:11px;color:#888">Safe Purchase</div>
        </div>
      `,
      category: 'Buttons',
      content: `
        <div class="text-center py-10 bg-gray-50">

          <a href="#order"
            class="inline-block px-12 py-4 bg-blue-600 text-white text-lg font-semibold rounded-full shadow-lg hover:bg-blue-700 hover:scale-105 transition duration-300">
            🛒 Buy With Confidence
          </a>

          <p class="text-gray-500 text-sm mt-4">
            ✔ Secure Checkout • ✔ Fast Delivery
          </p>

        </div>
      `
    });

    editor.BlockManager.add('cta-green-premium', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:20px;color:#16a34a;margin-bottom:6px">
            <i class="fas fa-check-circle"></i>
          </div>
          <strong>Green Premium Button</strong>
          <div style="font-size:11px;color:#888">Clean Conversion</div>
        </div>
      `,
      category: 'Buttons',
      content: `
        <section class="py-12 text-center bg-white">

          <a href="#order"
            class="inline-block px-14 py-4 bg-green-600 text-white text-lg font-semibold rounded-full shadow-lg transition duration-300 hover:bg-green-700 hover:shadow-xl active:scale-95">
            
            ✅ Order Now – Secure Checkout

          </a>

          <p class="text-gray-500 text-sm mt-4">
            Fast Delivery • 100% Halal • Cash On Delivery Available
          </p>

        </section>
      `
    });


    editor.BlockManager.add('cta-red-shake', {
  label: `
    <div style="text-align:center;padding:8px">
      <div style="font-size:20px;color:#ef4444;margin-bottom:6px">
        <i class="fas fa-bolt"></i>
      </div>
      <strong>Red Shake Button</strong>
      <div style="font-size:11px;color:#888">Every 5s Animation</div>
    </div>
  `,
  category: 'Buttons',
  content: `
    <style>
      @keyframes shake5 {
        0% { transform: translateX(0); }
        2% { transform: translateX(-4px); }
        4% { transform: translateX(4px); }
        6% { transform: translateX(-4px); }
        8% { transform: translateX(4px); }
        10% { transform: translateX(0); }
        100% { transform: translateX(0); }
      }

      .shake-every-5 {
        animation: shake5 3s infinite;
      }
    </style>

    <div class="text-center py-12 bg-white">

      <a href="#order"
        class="shake-every-5 inline-block px-12 py-4 bg-red-600 text-white text-lg font-bold rounded-full shadow-xl hover:bg-red-700 transition">
        🔥 Order Now – Limited Stock
      </a>

      <p class="text-sm text-gray-500 mt-4">
        Only Few Bottles Left
      </p>

    </div>
  `
    });
    editor.BlockManager.add('cta-gold-shake', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:20px;color:#facc15;margin-bottom:6px">
            <i class="fas fa-crown"></i>
          </div>
          <strong>Gold Shake Button</strong>
          <div style="font-size:11px;color:#888">Luxury Animation</div>
        </div>
      `,
      category: 'Buttons',
      content: `
        <style>
          @keyframes shake5lux {
            0% { transform: translateX(0); }
            2% { transform: translateX(-5px); }
            4% { transform: translateX(5px); }
            6% { transform: translateX(-5px); }
            8% { transform: translateX(5px); }
            10% { transform: translateX(0); }
            100% { transform: translateX(0); }
          }

          .shake-gold-5 {
            animation: shake5lux 3s infinite;
          }
        </style>

        <div class="text-center py-12 bg-black">

          <a href="#order"
            class="shake-gold-5 inline-block px-14 py-4 bg-yellow-400 text-black text-lg font-semibold rounded-full shadow-2xl hover:bg-yellow-300 transition">
            ✨ Get Premium Attar Now
          </a>

          <p class="text-yellow-300 mt-4 text-sm">
            Trusted By 12,000+ Customers
          </p>

        </div>
      `
    });
    editor.BlockManager.add('cta-blue-shake', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:20px;color:#2563eb;margin-bottom:6px">
            <i class="fas fa-paper-plane"></i>
          </div>
          <strong>Blue Shake Button</strong>
          <div style="font-size:11px;color:#888">Trust Builder</div>
        </div>
      `,
      category: 'Buttons',
      content: `
        <style>
          @keyframes shakeBlue5 {
            0% { transform: translateX(0); }
            2% { transform: translateX(-4px); }
            4% { transform: translateX(4px); }
            6% { transform: translateX(-4px); }
            8% { transform: translateX(4px); }
            10% { transform: translateX(0); }
            100% { transform: translateX(0); }
          }

          .shake-blue-5 {
            animation: shakeBlue5 3s infinite;
          }
        </style>

        <div class="text-center py-12 bg-white">

          <a href="#order"
            class="shake-blue-5 inline-block px-12 py-4 bg-blue-600 text-white text-lg font-semibold rounded-full shadow-xl hover:bg-blue-700 transition">
            🚀 Get Yours Today
          </a>

          <p class="text-gray-500 text-sm mt-4">
            Fast Delivery Available
          </p>

        </div>
      `
    });

    editor.BlockManager.add('cta-green-shake', {
  label: `
    <div style="text-align:center;padding:8px">
      <div style="font-size:20px;color:#16a34a;margin-bottom:6px">
        <i class="fas fa-check-circle"></i>
      </div>
      <strong>Green Shake Button</strong>
      <div style="font-size:11px;color:#888">High Conversion</div>
    </div>
  `,
  category: 'Buttons',
  content: `
    <style>
      @keyframes shakeGreen5 {
        0% { transform: translateX(0); }
        2% { transform: translateX(-5px); }
        4% { transform: translateX(5px); }
        6% { transform: translateX(-5px); }
        8% { transform: translateX(5px); }
        10% { transform: translateX(0); }
        100% { transform: translateX(0); }
      }

      .shake-green-5 {
        animation: shakeGreen5 3s infinite;
      }
    </style>

    <div class="text-center py-12 bg-gray-50">

      <a href="#order"
        class="shake-green-5 inline-block px-14 py-4 bg-green-600 text-white text-lg font-bold rounded-full shadow-2xl hover:bg-green-700 transition">
        ✅ Order Now – Secure Checkout
      </a>

      <p class="text-gray-600 text-sm mt-4">
        100% Halal & Alcohol Free
      </p>

    </div>
  `
    });







    // =======================
    // Media Blocks
    // =======================

    editor.BlockManager.add('youtube-video', {
      label: `
        <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-video"></i>
          </div>
          <strong>YouTube Video</strong>
          <div style="font-size:12px;color:#888">Responsive</div>
        </div>
      `,
      category: 'Media',
      content: `
        <div class="yt-video-wrapper">
          <iframe 
            src="https://www.youtube.com/embed/dQw4w9WgXcQ"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      `,
    });


    // =======================
    // Content Details Blocks
    // =======================

    editor.BlockManager.add('premium-content', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:22px;color:#facc15;margin-bottom:6px">
            <i class="fas fa-heading"></i>
          </div>
          <strong>Premium Headline</strong>
          <div style="font-size:11px;color:#888">Sales Title</div>
        </div>
      `,
      category: 'Content Details',
      content: `
        <section class="py-16 px-6 text-center bg-white">

          <!-- Badge -->
          <div class="inline-block mb-6 px-6 py-2 bg-amber-100 text-amber-700 text-sm font-medium rounded-full">
            100% Halal & Alcohol Free
          </div>

          <!-- Main Headline -->
          <h1 class="text-3xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
            Discover The Power Of 
            <span class="text-amber-500">Premium Oud Attar</span>
          </h1>

          <!-- Subheadline -->
          <p class="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-8">
            Long-lasting luxury fragrance crafted for Jummah, Eid & daily Sunnah.
          </p>

          <!-- Optional CTA -->
          <a href="#order"
            class="inline-block px-8 py-3 bg-black text-white rounded-full font-semibold shadow-lg hover:scale-105 transition">
            Shop Now
          </a>

        </section>
      `
    });
    editor.BlockManager.add('headline-image-description', {
      label: `
        <div style="text-align:center;padding:8px">
          <div style="font-size:22px;color:#facc15;margin-bottom:6px">
            <i class="fas fa-layer-group"></i>
          </div>
          <strong>Headline + Image</strong>
          <div style="font-size:11px;color:#888">Structured Layout</div>
        </div>
      `,
      category: 'Content Details',
      content: `
        <section class="py-20 px-6 bg-white text-center">

          <div class="max-w-4xl mx-auto">

            <!-- Main Headline -->
            <h1 class="text-3xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Experience The Beauty Of 
              <span class="text-amber-500">Premium Attar</span>
            </h1>

            <!-- Sub Headline -->
            <h2 class="text-lg md:text-2xl text-gray-600 mb-10 font-medium">
              Crafted For Elegance, Designed For Sunnah
            </h2>

            <!-- Image -->
            <div class="mb-10">
              <img 
                src="https://via.placeholder.com/450x450"
                class="w-72 md:w-96 mx-auto rounded-2xl shadow-xl"
                alt="Attar Image"
              />
            </div>

            <!-- Description Paragraph -->
            <p class="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto mb-8">
              Our premium halal attar is long-lasting, alcohol-free, and perfect for 
              Jummah, Eid, and daily use. Experience fragrance that defines purity 
              and sophistication.
            </p>

            <!-- Optional CTA -->
            <a href="#order"
              class="inline-block px-10 py-4 bg-black text-white rounded-full font-semibold shadow-lg hover:scale-105 transition">
              Order Now
            </a>

          </div>

        </section>
      `
    });
    editor.BlockManager.add('tw-r-image-content', {
      label: `
        <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-info-circle"></i>
          </div>
          <strong>Right Image Content</strong>
          <div style="font-size:12px;color:#888">Luxury Style</div>
        </div>
      `,
      category: 'Content Details',
      content: `
        <section class="py-16 px-6">
          <div class="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">
            
            <!-- Image -->
            <div class="w-full md:w-1/2 order-1 md:order-2">
              <img 
                src="https://via.placeholder.com/500x300"
                class="w-full rounded-xl shadow-lg"
              />
            </div>

            <!-- Content -->
            <div class="w-full md:w-1/2 order-2 md:order-1 text-center md:text-left">
              <h2 class="text-3xl font-bold mb-4">
                Engaging Heading
              </h2>
              <p class="text-gray-600 leading-relaxed">
                This layout shows image first on mobile and text first on desktop.
              </p>
              <a href="#" 
                class="inline-block mt-6 px-6 py-3 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition">
                Learn More
              </a>
            </div>

          </div>
        </section>
      `,
    });
    editor.BlockManager.add('tw-l-image-content', {
      label: `
        <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-list-check"></i>
          </div>
          <strong>Left Image Content</strong>
          <div style="font-size:12px;color:#888">Luxury Style</div>
        </div>
      `,
      category: 'Content Details',
      content: `
        <section class="py-16 px-6">
          <div class="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">
            <!-- Image -->
            <div class="w-full md:w-1/2">
              <img 
                src="https://via.placeholder.com/500x300"
                class="w-full rounded-xl shadow-lg"
              />
            </div>

            <!-- Content -->
            <div class="w-full md:w-1/2 text-center md:text-left">
              <h2 class="text-3xl font-bold mb-4">
                Engaging Heading
              </h2>
              <p class="text-gray-600 leading-relaxed">
                This layout shows image first on mobile and text first on desktop.
              </p>
              <a href="#" 
                class="inline-block mt-6 px-6 py-3 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition">
                Learn More
              </a>
            </div>

          

          </div>
        </section>
      `,
    });


    // =======================
    // Benifits Blocks
    // =======================

    editor.BlockManager.add('attar-benefits-gold', {
      label: `
        <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-certificate"></i>
          </div>
          <strong>Gold Benefits</strong>
          <div style="font-size:12px;color:#888">Luxury Style</div>
        </div>
      `,
      category: 'Benefits',
      content: `
        <section class="py-20 px-6 bg-gradient-to-b from-black via-gray-900 to-black text-white">
          <div class="max-w-6xl mx-auto text-center mb-14">
            <h2 class="text-3xl md:text-4xl font-bold mb-4">
              Why Choose Our Premium Attar?
            </h2>
            <p class="text-amber-200 max-w-2xl mx-auto">
              Crafted with purity and tradition to give you long-lasting fragrance.
            </p>
          </div>

          <div class="grid md:grid-cols-3 gap-10 text-center">
            
            <div class="p-8 bg-white/5 backdrop-blur-lg rounded-2xl border border-yellow-400/20 hover:scale-105 transition">
              <div class="text-4xl mb-4 text-yellow-400">🌿</div>
              <h3 class="text-xl font-semibold mb-3">100% Alcohol Free</h3>
              <p class="text-gray-300">Pure halal ingredients safe for daily Sunnah use.</p>
            </div>

            <div class="p-8 bg-white/5 backdrop-blur-lg rounded-2xl border border-yellow-400/20 hover:scale-105 transition">
              <div class="text-4xl mb-4 text-yellow-400">⏳</div>
              <h3 class="text-xl font-semibold mb-3">Long Lasting</h3>
              <p class="text-gray-300">Strong projection and long-lasting fragrance.</p>
            </div>

            <div class="p-8 bg-white/5 backdrop-blur-lg rounded-2xl border border-yellow-400/20 hover:scale-105 transition">
              <div class="text-4xl mb-4 text-yellow-400">🕌</div>
              <h3 class="text-xl font-semibold mb-3">Perfect for Jummah</h3>
              <p class="text-gray-300">Ideal fragrance for Jummah, Eid & special events.</p>
            </div>

          </div>
        </section>
      `
    });
    editor.BlockManager.add('attar-benefits-clean', {
    label: `
      <div style="text-align:center">
      <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-check-circle"></i>
          </div>
        <strong>Clean Benefits</strong>
        <div style="font-size:12px;color:#888">Modern Card</div>
      </div>
    `,
      category: 'Benefits',
      content: `
        <section class="py-20 px-6 bg-gray-100">
          <div class="max-w-6xl mx-auto text-center mb-14">
            <h2 class="text-3xl md:text-4xl font-bold mb-4">
              Benefits You’ll Love
            </h2>
            <p class="text-gray-600 max-w-2xl mx-auto">
              Experience elegance with every drop.
            </p>
          </div>

          <div class="grid md:grid-cols-3 gap-8">
            
            <div class="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition">
              <h3 class="text-xl font-semibold mb-3">Premium Quality</h3>
              <p class="text-gray-600">Imported fragrance oils with luxury finish.</p>
            </div>

            <div class="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition">
              <h3 class="text-xl font-semibold mb-3">Skin Friendly</h3>
              <p class="text-gray-600">Safe and gentle on all skin types.</p>
            </div>

            <div class="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition">
              <h3 class="text-xl font-semibold mb-3">Elegant Packaging</h3>
              <p class="text-gray-600">Perfect gift box presentation.</p>
            </div>

          </div>
        </section>
      `
    });
    editor.BlockManager.add('attar-benefits-icon-left', {
      label: `
        <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-leaf"></i>
          </div>
          <strong>Icon Left Benefits</strong>
          <div style="font-size:12px;color:#888">Professional</div>
        </div>
      `,
      category: 'Benefits',
      content: `
        <section class="py-20 px-6 bg-white">
          <div class="max-w-5xl mx-auto">

            <div class="text-center mb-14">
              <h2 class="text-3xl md:text-4xl font-bold mb-4">
                Why Our Attar Stands Out
              </h2>
              <p class="text-gray-600">
                Designed for fragrance lovers who value purity.
              </p>
            </div>

            <div class="space-y-8">

              <div class="flex items-start gap-6">
                <div class="text-3xl">🌸</div>
                <div>
                  <h3 class="text-xl font-semibold mb-2">Rich Aroma</h3>
                  <p class="text-gray-600">Deep oriental and floral blends.</p>
                </div>
              </div>

              <div class="flex items-start gap-6">
                <div class="text-3xl">🔥</div>
                <div>
                  <h3 class="text-xl font-semibold mb-2">Strong Projection</h3>
                  <p class="text-gray-600">Noticeable fragrance throughout the day.</p>
                </div>
              </div>

              <div class="flex items-start gap-6">
                <div class="text-3xl">🎁</div>
                <div>
                  <h3 class="text-xl font-semibold mb-2">Perfect Gift Choice</h3>
                  <p class="text-gray-600">Luxury presentation for special occasions.</p>
                </div>
              </div>

            </div>

          </div>
        </section>
      `
    });


    // =======================
    // Urgency and Scarcity Blocks
    // =======================

    editor.BlockManager.add('attar-scarcity-luxury', {
    label: `
      <div style="text-align:center">
        <div style="font-size:22px;margin-bottom:6px;color:#facc15">
            <i class="fas fa-fire"></i>
        </div>
        <strong>Luxury Scarcity</strong>
        <div style="font-size:12px;color:#888">Premium Feel</div>
      </div>
    `,
    category: 'Urgency and Scarcity',
    content: `
      <section class="py-20 px-6 bg-black text-white text-center relative overflow-hidden">

        <div class="absolute inset-0 bg-gradient-to-br from-black via-amber-900 to-yellow-700 opacity-80"></div>

        <div class="relative max-w-4xl mx-auto">

          <h2 class="text-3xl md:text-5xl font-bold mb-6">
            Exclusive Oud Collection
          </h2>

          <p class="text-amber-200 mb-8 text-lg">
            This premium batch is limited and will not be restocked.
          </p>

          <div class="inline-block border border-yellow-400 text-yellow-300 px-8 py-3 rounded-full text-xl font-semibold mb-8">
            Only 17 Bottles Remaining
          </div>

          <a href="#order"
            class="inline-block px-12 py-4 bg-yellow-400 text-black text-lg font-bold rounded-full shadow-2xl hover:scale-105 transition">
            Secure Your Bottle Now
          </a>

        </div>

      </section>
    `
    });

    editor.BlockManager.add('attar-urgency-flash', {
      label: `
        <div style="text-align:center">
        <div style="font-size:22px;margin-bottom:6px;color:#facc15">
            <i class="fas fa-hourglass-half"></i>
        </div>
          <strong>Flash Sale Urgency</strong>
          <div style="font-size:12px;color:#888">High Conversion</div>
        </div>
      `,
      category: 'Urgency and Scarcity',
      content: `
        <section class="py-16 px-6 bg-gradient-to-r from-red-700 to-red-500 text-white text-center">
          <div class="max-w-4xl mx-auto">

            <h2 class="text-3xl md:text-4xl font-bold mb-4">
              🔥 Flash Sale Ending Soon!
            </h2>

            <p class="text-lg mb-6">
              Special Jummah Offer – Only for Today
            </p>

            <div class="inline-block bg-white text-red-600 font-bold px-6 py-3 rounded-full text-xl shadow-lg mb-8">
              Only 23 Bottles Left
            </div>

            <div class="flex justify-center gap-4 text-2xl font-bold mb-8">
              <div class="bg-white/20 px-4 py-2 rounded">02h</div>
              <div class="bg-white/20 px-4 py-2 rounded">15m</div>
              <div class="bg-white/20 px-4 py-2 rounded">09s</div>
            </div>

            <a href="#order"
              class="inline-block px-10 py-4 bg-white text-red-600 font-semibold rounded-full shadow-xl hover:scale-110 transition">
              Order Now Before It’s Gone
            </a>

          </div>
        </section>
      `
    });
    editor.BlockManager.add('attar-urgency-social', {
      label: `
        <div style="text-align:center">
        <div style="font-size:22px;margin-bottom:6px;color:#facc15">
            <i class="fas fa-stopwatch"></i>
        </div>
          <strong>Urgency + Social Proof</strong>
          <div style="font-size:12px;color:#888">Sales Booster</div>
        </div>
      `,
      category: 'Urgency and Scarcity',
      content: `
        <section class="py-16 px-6 bg-gradient-to-r from-indigo-700 to-purple-700 text-white text-center">
          <div class="max-w-4xl mx-auto">

            <h2 class="text-3xl md:text-4xl font-bold mb-4">
              ⚡ High Demand Alert!
            </h2>

            <p class="text-lg mb-6">
              127+ Customers Ordered This Week
            </p>

            <div class="inline-block bg-white text-purple-700 font-bold px-6 py-3 rounded-full text-lg shadow-lg mb-8">
              Only 12 Bottles Left In Stock
            </div>

            <p class="mb-8 text-purple-100">
              Once Sold Out — Next Restock After 30 Days
            </p>

            <a href="#order"
              class="inline-block px-10 py-4 bg-white text-purple-700 font-semibold rounded-full shadow-xl hover:scale-110 transition">
              Get Yours Now
            </a>

          </div>
        </section>
      `
    });

    editor.BlockManager.add('attar-white-urgency', {
    label: `
      <div style="text-align:center">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
              <i class="fas fa-clock"></i>
          </div>
        <strong>White Urgency Block</strong>
        <div style="font-size:12px;color:#888">Clean Premium</div>
      </div>
    `,
    category: 'Urgency and Scarcity',
    content: `
      <section class="py-20 px-6 bg-white text-center relative overflow-hidden">

        <!-- Soft Background Glow -->
        <div class="absolute -top-20 -left-20 w-80 h-80 bg-amber-200 opacity-30 blur-3xl rounded-full"></div>
        <div class="absolute -bottom-20 -right-20 w-80 h-80 bg-yellow-300 opacity-30 blur-3xl rounded-full"></div>

        <div class="relative max-w-4xl mx-auto">

          <!-- Headline -->
          <h2 class="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Premium Halal Attar – Limited Stock
          </h2>

          <!-- Subheadline -->
          <p class="text-lg md:text-xl text-gray-600 mb-8">
            Long-lasting fragrance perfect for Jummah & daily Sunnah.
          </p>

          <!-- Scarcity Badge -->
          <div class="inline-block bg-red-100 text-red-600 font-semibold px-6 py-3 rounded-full text-lg shadow-md mb-8 animate-pulse">
            Only 18 Bottles Remaining
          </div>

          <!-- Image -->
          <div class="mb-10">
            <img 
              src="https://via.placeholder.com/350x350"
              class="w-64 md:w-80 mx-auto rounded-2xl shadow-xl border border-gray-200"
            />
          </div>

          <!-- CTA Button -->
          <a href="#order"
            class="inline-block px-12 py-4 bg-black text-white text-lg font-semibold rounded-full shadow-xl hover:scale-105 transition">
            Order Now Before It’s Sold Out
          </a>

        </div>
      </section>
    `
    });


    // =======================
    // Social Proof Blocks
    // =======================

    editor.BlockManager.add('attar-testimonials-clean', {
      label: `
        <div style="text-align:center;padding:10px">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
            <i class="fas fa-chart-line"></i>
          </div>
          <strong style="font-size:14px">Customer Reviews</strong>
          <div style="font-size:11px;color:#888">White Clean</div>
        </div>
      `,
      category: 'Social Proof',
      content: `
        <section class="py-20 px-6 bg-white">
          <div class="max-w-6xl mx-auto text-center">

            <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              What Our Customers Say
            </h2>
            <p class="text-gray-600 mb-12">
              Real reviews from verified buyers.
            </p>

            <div class="grid md:grid-cols-3 gap-8">

              <div class="p-8 bg-gray-50 rounded-2xl shadow-md">
                <div class="text-yellow-400 text-xl mb-4">★★★★★</div>
                <p class="text-gray-600 mb-6">
                  Long lasting fragrance. Jummah day এ সবাই জিজ্ঞেস করে কোন আতর!
                </p>
                <h4 class="font-semibold text-gray-900">Abdullah Rahman</h4>
              </div>

              <div class="p-8 bg-gray-50 rounded-2xl shadow-md">
                <div class="text-yellow-400 text-xl mb-4">★★★★★</div>
                <p class="text-gray-600 mb-6">
                  100% halal & pure smell. আমি দ্বিতীয়বার অর্ডার করেছি।
                </p>
                <h4 class="font-semibold text-gray-900">Mohammad Arif</h4>
              </div>

              <div class="p-8 bg-gray-50 rounded-2xl shadow-md">
                <div class="text-yellow-400 text-xl mb-4">★★★★★</div>
                <p class="text-gray-600 mb-6">
                  Premium packaging & strong projection. Highly recommended.
                </p>
                <h4 class="font-semibold text-gray-900">Saif Islam</h4>
              </div>

            </div>
          </div>
        </section>
      `
    });


    editor.BlockManager.add('attar-social-stats', {
      label: `
        <div style="text-align:center;padding:10px">
          <div style="font-size:22px;margin-bottom:6px;color:#facc15">
            <i class="fas fa-chart-line"></i>
          </div>
          <strong style="font-size:14px">Trust Statistics</strong>
          <div style="font-size:11px;color:#888">Numbers Proof</div>
        </div>
      `,
      category: 'Social Proof',
      content: `
        <section class="py-20 px-6 bg-gray-900 text-white text-center">
          <div class="max-w-5xl mx-auto">

            <h2 class="text-3xl md:text-4xl font-bold mb-12">
              Trusted By Thousands
            </h2>

            <div class="grid md:grid-cols-3 gap-8">

              <div>
                <h3 class="text-5xl font-bold text-yellow-400 mb-2">12,000+</h3>
                <p class="text-gray-300">Happy Customers</p>
              </div>

              <div>
                <h3 class="text-5xl font-bold text-yellow-400 mb-2">4.9/5</h3>
                <p class="text-gray-300">Average Rating</p>
              </div>

              <div>
                <h3 class="text-5xl font-bold text-yellow-400 mb-2">98%</h3>
                <p class="text-gray-300">Repeat Purchase Rate</p>
              </div>

            </div>
          </div>
        </section>
      `
    });








    

    editorRef.current = editor;
  }, [apiUrl, id]);

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <div
        id="blocks"
        style={{
          width: '250px',
          borderRight: '1px solid #ddd',
          padding: '10px',
        }}
      />
      <div id="gjs" style={{ flex: 1 }} />
    </div>
  );
};

export default LandingPageEditor;
